import { createContext, useContext } from "react";
export const BasenameContext = createContext("");
export const useBasename = () => useContext(BasenameContext);
//# sourceMappingURL=basenameContext.js.map